import React, { Component } from 'react';
import { Image } from 'react-bootstrap';
import { Metadata } from '../Metadata';
import PropTypes from 'prop-types';
import './NavbarHorizontal.css';

export class NavbarHorizontal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFormVisible: false,
        };

        this.toggleFormVisibility = this.toggleFormVisibility.bind(this);
    }

    static contextTypes = {
        selectedMenuItem: PropTypes.string,
        selectedMenuItemTitle: PropTypes.string,
        showMetadataButton: PropTypes.bool,
        setShowMetadataButton: PropTypes.func
    }

    componentDidMount() {
        this.context.setShowMetadataButton(false);
    }

    toggleFormVisibility() {
        this.setState((prevState) => ({
            isFormVisible: !prevState.isFormVisible,
        }));
    };

    render() {
        const { isFormVisible } = this.state;
        const { showMetadataButton } = this.context;

        return (
            <div className="navbar-horizontal btn-metadata-container">
                {showMetadataButton && (
                    <button
                        className="btn-metadata larger-icon"
                        onClick={this.toggleFormVisibility}
                    >
                        <span className="glyphicon glyphicon-question-sign"></span>
                    </button>
                )}

                <Image className="logo" src="icons/logo.png" />

                {isFormVisible && (
                    <Metadata
                        show={isFormVisible}
                        onHide={this.toggleFormVisibility}
                        item={this.context.selectedMenuItem}
                        label={this.context.selectedMenuItemTitle}
                    />
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/nav/NavbarHorizontal.js